/**
 * Колоните на футъра в прегледите на отчетите (личен и на заведението).
 * Записаният отчет — три бутона: Затвори · Печат · Печат (POS). Прегледът преди
 * издаване — четири: Отказ · Печат · Печат ПОС · Нулирай; на тесен екран не се
 * събират на един ред и минават 2×2 (Нулирай остава долу вдясно).
 */
export const reportFooterColumns = (isPreviewMode: boolean, isNarrow: boolean) => {
  if (!isPreviewMode) return "grid-cols-[1fr_1fr_2fr]";
  return isNarrow ? "grid-cols-2" : "grid-cols-[1fr_1fr_1.2fr_1.6fr]";
};
